import * as go from 'gojs';
import noop from 'lodash/noop';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { EMOJI_LAYER_NAME } from '../config/part-names';
import { emojiNodeTemplate } from '../emoji-node';

export const setupEmojiNode = (diagram: go.Diagram, categoryName: string) => {
  setupEmojiLayer(diagram);
  registerNodeTemplate(diagram, categoryName, emojiNodeTemplate());
  return noop;
};

const setupEmojiLayer = (diagram: go.Diagram) => {
  const $ = go.GraphObject.make;
  const emojiLayer = $(go.Layer, { name: EMOJI_LAYER_NAME });
  const adornmentLayer = diagram.findLayer('Adornment');
  if (!adornmentLayer) {
    return;
  }
  diagram.addLayerBefore(emojiLayer, adornmentLayer);
};
